import { Component,OnInit,OnDestroy,AfterViewInit,ViewChild,ElementRef } from '@angular/core';
import { NgbModal,NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { takeWhile } from "rxjs/operators";
import {
    NgbDate
    ,NgbCalendar
    ,NgbDateParserFormatter
    ,NgbDatepickerI18n
    ,NgbDateStruct
} from '@ng-bootstrap/ng-bootstrap';

import {
    FvmsCommonService
    ,FvmsApiAuthService
    ,FvmsApiDtgDownloadService
    ,I18n
    ,I18nDatePicker
} from "src/app/shared/service";
import {
    DtgListType
} from "src/app/shared/vo";
import {
    FilterLeftPadd
} from "src/app/shared/filter";

@Component({
    selector: "[dtg-download-etas-request-list]"
    ,templateUrl: './dtg.download.etas.request.list.component.html'
    ,styleUrls: ["./dtg.download.etas.request.list.component.scss"]
    ,providers: [I18n, {provide: NgbDatepickerI18n, useClass: I18nDatePicker},FilterLeftPadd]
})
export class DtgDownloadEtasRequestListComponent implements OnInit,OnDestroy,AfterViewInit {
    isContinue:boolean = true;
    DtgListType = DtgListType;
    currentUserInfo:any;
    userGroupId:number;
    dtgTeamId:string = "";
    companyInfo:any;
    listCar:any[];
    isCarAll:boolean = false;
    searchInfo:any = {
        listUnitId:[]
        ,dtgRegDtFrom:null
        ,dtgRegDtTo:null
        ,filePw:null
        ,email:null
    };
    datetimeInfo:any;
    hoveredDate: NgbDate;
    isSaturday = (date: NgbDate) =>  this.calendar.getWeekday(date) == 6;
    isSunday = (date: NgbDate) =>  this.calendar.getWeekday(date) == 7;

    displayDateFrom:NgbDate;
    displayDateTo:NgbDate;
    minDate:NgbDate = new NgbDate(2017,1,1);
    maxDate:NgbDate;
    maxRange:number = 31;
    reqErrMsg:string;
    @ViewChild('modalWarn') modalWarn:ElementRef;

    constructor(
        private modalService: NgbModal
        ,private fvmsCommonService:FvmsCommonService
        ,private fvmsApiAuthService:FvmsApiAuthService
        ,private fvmsApiDtgDownloadService:FvmsApiDtgDownloadService
        ,private calendar: NgbCalendar
        ,private filterLeftPadd:FilterLeftPadd
    ) {
        this.currentUserInfo = this.fvmsApiAuthService.getLoginUserInfo();
        this.userGroupId = parseInt(this.currentUserInfo.userGroupId);
        if(this.userGroupId > 100){
            this.dtgTeamId = this.currentUserInfo.teamId;
        }
        this.companyInfo = this.fvmsCommonService.getCompanyInfo();
        this.fvmsCommonService.subscribeCompanyInfo()
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(companyInfo => {
                this.companyInfo = companyInfo;
                this.reloadListCar();
            });

        let today = this.calendar.getToday();
        this.maxDate = this.calendar.getNext(today,'d',-1);
        // 초기값 없을경우 설정
        if(!this.datetimeInfo){
            this.datetimeInfo = {
                fromDate : this.maxDate
                ,toDate : this.maxDate
                ,fromTime : "00:00:00" //시간까지 선택으로 바뀌면 사용
                ,toTime : "23:59:59" //시간까지 선택으로 바뀌면 사용
            };
        }
    }

    ngOnInit() {
        if(this.datetimeInfo){
            this.displayDateFrom = this.datetimeInfo.fromDate;
            this.displayDateTo = this.datetimeInfo.toDate;
            this.searchInfo.dtgRegDtFrom = `${this.filterLeftPadd.transform(this.displayDateFrom.year,4)}-${this.filterLeftPadd.transform(this.displayDateFrom.month,2)}-${this.filterLeftPadd.transform(this.displayDateFrom.day,2)}`;
            this.searchInfo.dtgRegDtTo = `${this.filterLeftPadd.transform(this.displayDateTo.year,4)}-${this.filterLeftPadd.transform(this.displayDateTo.month,2)}-${this.filterLeftPadd.transform(this.displayDateTo.day,2)}`;
        }
        this.searchInfo.filePw = new Date().getTime();
        this.reloadListCar();
    }

    ngOnDestroy() {
        this.isContinue = false;
    }
    
    ngAfterViewInit() {
        
    }

    reloadListCar(){
        let searchInfo = {
            companyId:this.companyInfo?.companyId || 0
            ,dtgEid:this.companyInfo?.dtgEid || ""
            ,dtgTeamId:this.currentUserInfo?.teamId || ""
        };
        this.fvmsApiDtgDownloadService.getListCarInfo(searchInfo)
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(apiResponse => {
                if(apiResponse.resultStatus === "ok"){
                    // console.log("reloadListCar",apiResponse);
                    if(apiResponse.resultValue){
                        this.listCar = apiResponse.resultValue;
                        this.listCar = this.listCar.map(item => {
                            item.checked = false;
                            return item;
                        });
                        console.log("reloadListCar",this.listCar);
                    }
                }
            });
    }

    changeCarAll(e){
        // console.log("changeCarAll",e);
        this.listCar = this.listCar.map(item => {
            item.checked = e;
            return item;
        });
    }

    onDateSelection(date: NgbDate) {
        if (!this.displayDateFrom && !this.displayDateTo) {
            //처음 클릭
            this.displayDateFrom = date;
            this.searchInfo.dtgRegDtFrom = `${this.filterLeftPadd.transform(this.displayDateFrom.year,4)}-${this.filterLeftPadd.transform(this.displayDateFrom.month,2)}-${this.filterLeftPadd.transform(this.displayDateFrom.day,2)}`;
        } else if (this.displayDateFrom && !this.displayDateTo) {
            // && date.after(this.displayDateFrom)
            //뒤에 선택한 일자가 먼저 선택한 일자보다 작은 경우 스왑
            if(date.before(this.displayDateFrom) === true){
                let tmpDate = new NgbDate(this.displayDateFrom.year,this.displayDateFrom.month,this.displayDateFrom.day);
                let newDate = new NgbDate(date.year,date.month,date.day);
                this.displayDateFrom = newDate;
                date = tmpDate;
                this.searchInfo.dtgRegDtFrom = `${this.filterLeftPadd.transform(this.displayDateFrom.year,4)}-${this.filterLeftPadd.transform(this.displayDateFrom.month,2)}-${this.filterLeftPadd.transform(this.displayDateFrom.day,2)}`;
            }

            if(date.equals(this.displayDateFrom) === false){
                let tmpMinDate = this.calendar.getNext(date, 'd', this.maxRange * -1);
                if(this.displayDateFrom.before(tmpMinDate) === true){
                    this.initDateInfo();
                    alert(`최대 ${this.maxRange}일까지 검색 가능합니다`);
                    return;
                }
            }

            this.displayDateTo = date;
            this.searchInfo.dtgRegDtTo = `${this.filterLeftPadd.transform(this.displayDateTo.year,4)}-${this.filterLeftPadd.transform(this.displayDateTo.month,2)}-${this.filterLeftPadd.transform(this.displayDateTo.day,2)}`;
            this.datetimeInfo.fromDate = this.displayDateFrom;
            this.datetimeInfo.toDate = this.displayDateTo;
            // this.fvmsCommonService.setDateInfo(this.datetimeInfo);
        } else {
            //from,to 선택 후에 다시 클릭 -> 초기화
            this.initDateInfo();
            this.displayDateFrom = date;
            this.searchInfo.dtgRegDtFrom = `${this.filterLeftPadd.transform(this.displayDateFrom.year,4)}-${this.filterLeftPadd.transform(this.displayDateFrom.month,2)}-${this.filterLeftPadd.transform(this.displayDateFrom.day,2)}`;
        }
    }

    isHovered(date: NgbDate) {
        return this.displayDateFrom && !this.displayDateTo && this.hoveredDate && date.after(this.displayDateFrom) && date.before(this.hoveredDate);
    }
    
    isInside(date: NgbDate) {
        return date.after(this.displayDateFrom) && date.before(this.displayDateTo);
    }
    
    isRange(date: NgbDate) {
        return date.equals(this.displayDateFrom) || date.equals(this.displayDateTo) || this.isInside(date) || this.isHovered(date);
    }

    initDateInfo(){
        this.displayDateFrom = undefined;
        this.displayDateTo = undefined;
        this.searchInfo.dtgRegDtFrom = undefined;
        this.searchInfo.dtgRegDtTo = undefined;
        this.minDate = new NgbDate(2017,1,1);
        let today = this.calendar.getToday();
        this.maxDate = this.calendar.getNext(today,'d',-1);
    }

    clickOpen(datepicker){
        this.initDateInfo();
        this.displayDateFrom = this.datetimeInfo.fromDate;
        this.displayDateTo = this.datetimeInfo.toDate;
        datepicker.toggle();
    }

    clickOk(datepicker){
        if(this.displayDateFrom){
            if(!this.displayDateTo){
                this.displayDateTo = this.displayDateFrom;
            }
            this.datetimeInfo.fromDate = this.displayDateFrom;
            this.datetimeInfo.toDate = this.displayDateTo;
        }
        datepicker.close();
    }

    selectToday(){
        this.initDateInfo();
        this.onDateSelection(this.calendar.getToday());
    }

    clickDownloadRequest(){
        // console.log("clickDownloadRequest",this.searchInfo);
        if(!this.searchInfo.email){
            this.reqErrMsg = "이메일을 입력 해 주세요";
            this.modalService.open(this.modalWarn,{
                centered:true
                ,size: "sm"
                ,backdrop:"static"
                //windowClass: "dark-modal"
                ,scrollable: true
            }).result.then((result) => {
                console.log("clickDownloadRequest",result);
            },(reason) => {
                console.log("clickDownloadRequest",reason);
            });
            return;
        }
        if(!this.searchInfo.dtgRegDtFrom){
            this.reqErrMsg = "기간을 선택 해 주세요";
            this.modalService.open(this.modalWarn,{
                centered:true
                ,size: "sm"
                ,backdrop:"static"
                //windowClass: "dark-modal"
                ,scrollable: true
            }).result.then((result) => {
                console.log("clickDownloadRequest",result);
            },(reason) => {
                console.log("clickDownloadRequest",reason);
            });
            return;
        }
        if(!this.searchInfo.dtgRegDtTo){
            this.reqErrMsg = "기간을 선택 해 주세요";
            this.modalService.open(this.modalWarn,{
                centered:true
                ,size: "sm"
                ,backdrop:"static"
                //windowClass: "dark-modal"
                ,scrollable: true
            }).result.then((result) => {
                console.log("clickDownloadRequest",result);
            },(reason) => {
                console.log("clickDownloadRequest",reason);
            });
            return;
        }
        if(!this.searchInfo.filePw){
            this.reqErrMsg = "파일 비밀번호를 입력 해 주세요";
            this.modalService.open(this.modalWarn,{
                centered:true
                ,size: "sm"
                ,backdrop:"static"
                //windowClass: "dark-modal"
                ,scrollable: true
            }).result.then((result) => {
                console.log("clickDownloadRequest",result);
            },(reason) => {
                console.log("clickDownloadRequest",reason);
            });
            return;
        }

        this.searchInfo.listUnitId = this.listCar.filter((item) => {
            return item.checked === true;
        }).map((item) => item.dtgUnitId);

        if(!this.searchInfo.listUnitId || this.searchInfo.listUnitId.length === 0){
            this.reqErrMsg = "차량을 선택 해 주세요";
            this.modalService.open(this.modalWarn,{
                centered:true
                ,size: "sm"
                ,backdrop:"static"
                //windowClass: "dark-modal"
                ,scrollable: true
            }).result.then((result) => {
                console.log("clickDownloadRequest",result);
            },(reason) => {
                console.log("clickDownloadRequest",reason);
            });
            return;
        }

        this.fvmsCommonService.setIsLoading(true);
        // console.log("clickDownloadRequest",this.searchInfo);
        this.fvmsApiDtgDownloadService.etasFileRequest(this.searchInfo)
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(apiResponse => {
                if(apiResponse.resultStatus === "ok"){
                    // console.log("reloadListCar",apiResponse);
                    if(apiResponse.resultValue){
                        console.log("clickDownloadRequest",this.listCar);
                        this.reqErrMsg = "<div>제출파일 생성을 요청했습니다.</div><div>파일이 완성되면 이메일로 보내드립니다.</div>";
                        this.modalService.open(this.modalWarn,{
                            centered:true
                            ,size: "sm"
                            ,backdrop:"static"
                            //windowClass: "dark-modal"
                            ,scrollable: true
                        }).result.then((result) => {
                            console.log("clickDownloadRequest",result);
                        },(reason) => {
                            console.log("clickDownloadRequest",reason);
                        });
                    }
                }
            }
            ,err => {
                console.error("clickDownloadRequest",err);
                this.reqErrMsg = "제출파일 생성을 요청을 실패했습니다.";
                this.modalService.open(this.modalWarn,{
                    centered:true
                    ,size: "sm"
                    ,backdrop:"static"
                    //windowClass: "dark-modal"
                    ,scrollable: true
                }).result.then((result) => {
                    console.log("clickDownloadRequest",result);
                },(reason) => {
                    console.log("clickDownloadRequest",reason);
                });
            }
            ,() => {
                this.fvmsCommonService.setIsLoading(false);
            });
    }
}